export default __webpack_public_path__ + "search-examples-uitextfield-search-1200-2dbc60762138c83b0d3d31a3407911a9.webp";